import PropTypes from 'prop-types';
import React from 'react';

import styles from './DisplayTime.module.scss';

export const DisplayTime = ({ time, zone, size = 'panel' }) => {
  const [clock, meridiem] = `${time || ''}`.split(' ');
  return (
    <span className={`${styles.start} ${size === 'folded' ? styles.folded : ''}`}>
      {clock}
      <span className={styles.stack}>
        {meridiem && <span className={styles.meridiem}>{meridiem}</span>}
        {zone && <span className={styles.zone}>{zone}</span>}
      </span>
    </span>
  );
};

export const DisplayEndTime = ({ children }) => <span className={styles.end}>{children}</span>;

DisplayTime.propTypes = {
  time: PropTypes.string,
  zone: PropTypes.string,
  size: PropTypes.oneOf(['panel', 'folded']),
};
DisplayEndTime.propTypes = { children: PropTypes.node };
